import Route from 'cio/routes/base';
import PersonSubjectsIndexController from './controller';

import CustomerModel from 'cio/models/customer';
import Transition from '@ember/routing/-private/transition';

export default class PersonSubjectsIndexControllerRoute extends Route {
  setupController(controller: PersonSubjectsIndexController, model: CustomerModel, transition: Transition) {
    super.setupController(controller, model, transition);
    controller.set('person', this.modelFor('person'));
  }
}
